import React from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';
import * as yup from 'yup';
import { equals } from 'ramda';
import { SelectField } from '../common/FormFields';
import * as api from './../../api/postApi';
import { buildOptionsFromArray } from '../../utils/buildOptionsFromArray';

const CloneArticleModal = ({ sites, cloneNewsItem, article }) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [sections, setSections] = React.useState([]);

  const handleSubmit = async ({ siteId, sectionId }, formik) => {
    cloneNewsItem(siteId, sectionId, article);
    setOpen(false);
    formik.resetForm();
  };

  const getSortOrder = section => {
    const title = section.toUpperCase();
    switch (title) {
      case 'RESTAURANTS + BARS':
        return 0;
      case 'CITY LIFE':
        return 1;
      case 'ENTERTAINMENT':
        return 2;
      case 'TRAVEL':
        return 3;
      case 'REAL ESTATE':
        return 4;
      case 'ARTS':
        return 5;
      case 'SOCIETY':
        return 6;
      case 'HOME + DESIGN':
        return 7;
      case 'FASHION + BEAUTY':
        return 8;
      case 'INNOVATION':
        return 9;
      case 'SPORTS':
        return 10;
      default:
        return 99;
    }
  };

  const handleSiteChange = async siteId => {
    setLoading(true);
    const { sections } = await api.getSections(siteId);
    const news = sections?.find(s => s?.title?.toLowerCase() === 'news');
    const isNewsSections = ({ parent_id }) => equals(news?.id, parent_id);
    const sectionChoices = sections
      .filter(isNewsSections)
      .sort((a, b) => getSortOrder(a.title) - getSortOrder(b.title));
    const options = buildOptionsFromArray(sectionChoices, 'title', 'id');
    setSections(options);
    setLoading(false);
  };

  const validationSchema = article?.is_event
    ? yup.object({
        siteId: yup.string().required('A site is required'),
      })
    : yup.object({
        siteId: yup.string().required('A site is required'),
        sectionId: yup.string().required('A section is required'),
      });

  return (
    <Formik
      initialValues={{ siteId: '' }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          size="small"
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Dropdown.Item icon="copy" content="Clone article" />}
        >
          <Modal.Header>Clone Article</Modal.Header>
          <Modal.Content>
            <Form onSubmit={formik.handleSubmit} widths="equal">
              <Form.Group>
                <Form.Field>
                  <strong>Destination City</strong>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    options={sites}
                    id="siteId"
                    name="siteId"
                    value={formik.values.siteId}
                    onChange={(e, { name, value }) => {
                      formik.setFieldValue(name, value);
                      handleSiteChange(value);
                    }}
                    size="small"
                    error={Boolean(formik.errors.siteId)}
                  />
                </Form.Field>
              </Form.Group>
              {!article.is_event && (
                <Form.Group>
                  <SelectField
                    label="Section"
                    id="sectionId"
                    name="sectionId"
                    formik={formik}
                    loading={loading}
                    options={sections}
                    value={formik.values.sectionId}
                    onChange={formik.handleChange}
                  />
                </Form.Group>
              )}
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              content="Save"
              labelPosition="left"
              icon="save"
              disabled={!formik.isValid}
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  sites: selectors.admin.cultureMapSiteOptions(state),
});

const mapDispatchToProps = dispatch => ({
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  cloneNewsItem: bindActionCreators(actions.content.cloneNewsItem, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CloneArticleModal);
